import type { WorkspaceAuditAction } from './types'
import { auditActions } from './auditActions'
import { visibleAuditActions } from './visibleAuditActions'

export type ActionFilterOption = {
  label: string
  value: WorkspaceAuditAction
}

export type ActionFilterGroup = {
  label: string
  options: ActionFilterOption[]
}

export type ActionFilterItem =
  | {
      kind: 'all'
      label: 'All actions'
    }
  | ({
      kind: 'action'
      group: string
      buttonLabel: string
    } & ActionFilterOption)

// Object.entries loses the enum keys; auditActions is checked against the API enum.
const actions = Object.entries(auditActions) as [
  WorkspaceAuditAction,
  { group: string; label: string },
][]

export const actionFilterGroups = actions.reduce<ActionFilterGroup[]>(
  (groups, [value, { group, label }]) => {
    if (value === 'UNKNOWN' || !visibleAuditActions.includes(value))
      return groups
    const existingGroup = groups.find(item => item.label === group)
    const option = { value, label }
    if (existingGroup) existingGroup.options.push(option)
    else groups.push({ label: group, options: [option] })
    return groups
  },
  []
)

export const actionFilterItems: ActionFilterItem[] = [
  { kind: 'all', label: 'All actions' },
  ...actionFilterGroups.flatMap(group =>
    group.options.map(option => ({
      kind: 'action' as const,
      group: group.label,
      buttonLabel: `${group.label}: ${option.label}`,
      ...option,
    }))
  ),
]
